import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';

import * as styles from './styles.module.scss';

type StartProps = {
	className?: string,
	onClick: () => void
}

export const Start: FC<StartProps> = ({className, onClick}) => (
	<div className={classNames(styles.start, className)}>
		<Button onClick={onClick} variant='light'>
			Explain my results
		</Button>
	</div>
);
